import {
  sharedStarIcon,
  sharedProgramIntro,
  getSharedGalleryImages,
  initiativePlcIcon,
  initiativeCulturalIcon,
  initiativeWomenIcon,
  initiativeGovernanceIcon,
  initiativeNationIcon,
  sharedSkillCommunicationIcon,
  sharedSkillTimeManagementIcon,
} from '../assets/index'
import skillTeamBuilding from '../assets/icons/leadership/skills/team-building.png'
import skillCriticalThinking from '../assets/icons/leadership/skills/critical-thinking.png'
import skillPublicSpeaking from '../assets/icons/leadership/skills/public-speaking.png'
import skillProblemSolving from '../assets/icons/leadership/skills/problem-solving.png'

export const leadershipHero = {
  title: 'Leadership Development',
  subtitle:
    'Comprehensive training programs that build essential leadership skills, decision-making abilities, and strategic thinking in young individuals through workshops, seminars, and hands-on experiences.',
  cta: 'Join The Program',
}

export const leadershipIntro = {
  image: sharedProgramIntro,
  text:
    'Leadership Development at Disha Foundation is designed to help young individuals unlock their potential, strengthen their character, and develop the confidence to lead with purpose. Through workshops, mentorship, team activities, and real-world experiences, participants gain practical leadership skills that prepare them for personal and professional success.',
}

export const leadershipWhy = {
  title: 'Why Leadership Matters ?',
  bulletIcon: sharedStarIcon,
  items: [
    'Build Self Confidence',
    'Improve Communication Skills',
    'Enhance Decision Making',
    'Strengthen Teamwork',
    'Develop Problem Solving Abilities',
    'Foster Social Responsibility',
  ],
}

export const leadershipSkills = [
  {
    title: 'Communication Skills',
    description: 'Express ideas clearly and confidently.',
    iconSrc: sharedSkillCommunicationIcon,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Team Building',
    description: 'Learn collaboration, trust, and teamwork.',
    iconSrc: skillTeamBuilding,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Critical Thinking',
    description: 'Analyze situations and make informed decisions.',
    iconSrc: skillCriticalThinking,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Public Speaking',
    description: 'Develop confidence to address and inspire audiences.',
    iconSrc: skillPublicSpeaking,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
  {
    title: 'Problem Solving',
    description: 'Find effective solutions to real-world challenges.',
    iconSrc: skillProblemSolving,
    iconBgColor: 'rgba(7,30,183,0.12)',
  },
  {
    title: 'Time Management',
    description: 'Improve productivity and personal discipline.',
    iconSrc: sharedSkillTimeManagementIcon,
    iconBgColor: 'rgba(183,7,171,0.12)',
  },
]

export const leadershipStats = [
  { value: '10,000+', label: 'Youth Empowered' },
  { value: '100+', label: 'Leadership Programs' },
  { value: '500+', label: 'Volunteers Engaged' },
  { value: '50+', label: 'Community Initiatives' },
]

export const leadershipInitiatives = [
  {
    title: 'Public Leadership Camp (PLC)',
    description:
      'Our flagship residential program that transforms youth through intensive leadership training, team building activities, motivational sessions, and real-world problem-solving exercises.',
    path: '/plc-4',
    iconSrc: initiativePlcIcon,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Cultural Initiatives',
    description:
      "Programs celebrating India's rich cultural heritage through festivals, traditional arts, music, dance, and cultural exchange activities that strengthen national identity and pride.",
    path: '/programs/cultural-initiatives',
    iconSrc: initiativeCulturalIcon,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Women Empowerment',
    description:
      "Dedicated initiatives supporting women's education, skill development, entrepreneurship, and leadership roles to create equal opportunities and foster gender equality in society.",
    path: '/programs/women-empowerment',
    iconSrc: initiativeWomenIcon,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
  {
    title: 'Good Governance Awareness',
    description:
      'Educational programs promoting transparency, accountability, civic responsibility, and active citizen participation in democratic processes and governance systems.',
    path: '/programs/good-governance-awareness',
    iconSrc: initiativeGovernanceIcon,
    iconBgColor: 'rgba(7,30,183,0.12)',
  },
  {
    title: 'Nation Building Activities',
    description:
      "Community service projects, social awareness campaigns, environmental initiatives, and patriotic programs that contribute to India's development and national progress.",
    path: '/programs/nation-building-activities',
    iconSrc: initiativeNationIcon,
    iconBgColor: 'rgba(183,7,171,0.12)',
  },
]

export const leadershipGallery = getSharedGalleryImages('Leadership Development', [
  'Leadership program group gathering',
  'Leadership workshop session',
  'Youth leadership event',
  'Speaker at leadership summit',
  'Leadership team meeting',
])
